import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form", "select", "modal", "destination", "error"]

  connect() {
    this.confirmed = false
  }

  guard(event) {
    if (this.confirmed) return

    event.preventDefault()
    const select = this.selectTarget
    if (!select.value) {
      this.errorTarget.textContent = "Choose the event that should receive these sessions."
      this.errorTarget.hidden = false
      return
    }

    this.errorTarget.hidden = true
    this.destinationTarget.textContent = select.options[select.selectedIndex].text
    $(this.modalTarget).modal("show")
  }

  confirm(event) {
    event.preventDefault()
    this.confirmed = true
    $(this.modalTarget).modal("hide")
    this.formTarget.submit()
  }
}
